/**
 * Redux actions for the info dialog.
 * @module redux/actions/info
 */

import { createAction } from 'redux-actions';
import { getLuciInformation as apiGetLuciInformation } from '../api/info';

export const REQUEST_INFO = 'INFO/REQUEST_INFO';
export const REQUEST_INFO_FAILED = 'INFO/REQUEST_INFO_FAILED';
export const RECEIVED_INFO = 'INFO/RECEIVED_INFO';

export const getLuciInformation = () => (dispatch, getState) => {
  if (!getState().info.loading) {
    dispatch(createAction(REQUEST_INFO)());
    apiGetLuciInformation()
      .then(info =>
        dispatch(
          createAction(RECEIVED_INFO)({
            username: info.username,
            licensedOptions: info.licensedOptions,
            camioServer: info.camioServer,
            camioServerIp: info.camioServerIp,
            camioVersion: info.camioVersion,
            serverStatus: info.serverStatus,
            chyronCopyright: info.chyronCopyright
          })
        )
      )
      .catch(error => {
        console.log(error);
        return dispatch(createAction(REQUEST_INFO_FAILED)());
      });
  }
};

export const actions = {
  getLuciInformation
};



// WEBPACK FOOTER //
// ./app/actions/info.js